import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import Popover from "@mui/material/Popover";
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";
import { endpoint } from "views/pages/manage/common/constant";
import {
  fetchAllPostPromisedData,
  getFormattedDate,
  getFormattedTime,
} from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { Typography } from "@mui/material";

export const ViewQuotationDetails = ({ userId, createdAt }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const open = Boolean(anchorEl);
  const id = open ? "quotation-details-popover" : undefined;

  useEffect(() => {
    setUserDetails(null);
  }, [userId]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);

    // 🔹 Fetch only once
    if (!userDetails) {
      getUserDetails();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getUserDetails = async () => {
    try {
      setIsFetching(true);
      const url = `${endpoint.searchEmployeeDetails}?offset=0&limit=50`;

      const resp =
        userId &&
        (await fetchAllPostPromisedData(url, {
          searchByValue: userId,
          searchBy: "userId",
        }));

      if (resp) {
        const userData = resp?.data?.employeeDataList?.find(
          (item) => item.employeeId === userId
        );
        setUserDetails(userData || null);
      } else {
        setUserDetails(null);
      }
    } catch (error) {
      setUserDetails(null);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <>
      {/* 🔹 Anchor */}
      <span
        aria-describedby={id}
        onClick={handleOpen}
        style={{ cursor: "pointer" }}
      >
        <InfoIconSolid />
      </span>

      {/* 🔹 Popover */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          zIndex: 1300,
          "& .MuiPopover-paper": {
            marginTop: "5px",
            boxShadow: "0px 0px 9px rgba(0,0,0,0.5)",
            maxHeight: "400px",
            borderRadius: "12px",
          },
        }}
      >
        <Card className="mb-0 regular-body label-color">
          {isFetching ? (
            <div className="p-2 text-bold">Loading...</div>
          ) : (
            <div className="p-2 ml-2">
              <div>
                <Typography component="span" fontWeight={600}>
                  Created on: {" "}
                </Typography>
                {getFormattedDate(createdAt, "DD-MM-YYYY")} at{" "}
                {getFormattedTime(createdAt)}
              </div>

              <div>
                <Typography component="span" fontWeight={600}>
                  Created by: {" "}
                </Typography>
                {"  " + userId + " " + (userDetails?.employeeName || "-") + "  "}
              </div>
            </div>
          )}
        </Card>
      </Popover>
    </>
  );
};

export default ViewQuotationDetails;
